import { createChallenge } from '../helper/challenge-implementation-helper';
export class EmailOnlyChallengeRequest {
    constructor(baseUrl, request) {
        this.baseUrl = baseUrl;
        this.request = request;
    }
    async createChallenge(options) {
        return createChallenge(this.baseUrl, this.request, options);
    }
}
/** @public */
export class EmailOnlyOtp {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    withScope(scope) {
        this.scope = scope;
        return this;
    }
    withRequestFrom(requestFrom) {
        this.requestFrom = requestFrom;
        return this;
    }
    withEmail(email) {
        this.email = email;
        return this;
    }
    build() {
        const request = {
            authFactor: 'EMAIL_ONLY_OTP',
            scope: this.scope,
            requestFrom: this.requestFrom,
            payload: {
                email: this.email,
            },
        };
        return new EmailOnlyChallengeRequest(this.baseUrl, request);
    }
}
//# sourceMappingURL=email-only-otp.js.map